import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconBookmarkFilledStyle0 = cosmosIconCss;

const CosmosIconBookmarkFilled$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconBookmarkFilled extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '292f4b89971336471423c7ec89e11193e8a38f33', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '260997502420df1b585b1b30d17368c229753e16', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '4e65bbb5680b810d8f06bd0ab2aef339ffc99bf9', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M5.5 3a.5.5 0 0 0-.5.5v15.597a.4.4 0 0 0 .669.296L11 14.557l5.331 4.836a.4.4 0 0 0 .669-.296V3.5a.5.5 0 0 0-.5-.5h-11Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconBookmarkFilledStyle0; }
}, [1, "cosmos-icon-bookmark-filled", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-bookmark-filled"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-bookmark-filled":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconBookmarkFilled$1);
            }
            break;
    } });
}

const CosmosIconBookmarkFilled = CosmosIconBookmarkFilled$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconBookmarkFilled, defineCustomElement };
